import { connect } from "react-redux"
import CardsSectionWidget from "QuorumGrassroots/widgets/CardsSection/components/index"
import { cardsSectionConnection } from "QuorumGrassroots/widgets/CardsSection/selectors"
import { withRouter } from "QuorumGrassroots/withRouter"

export default withRouter(connect(cardsSectionConnection, null)(CardsSectionWidget))
